<template>
  <div id="bto-parts-palette-list">
    <ul :class="selectedPartsClass">
      <li
        v-for="(pid, key) in partsSortNum"
        :key="key"
        :id="'beads_' + partsInfo[pid].beadId"
        :class="partsInfo[pid].beadTypes + partsInfo[pid].labelCode"
        v-show="
          isEnabled({
            labelCode: partsInfo[pid].labelCode,
            beadTypes: partsInfo[pid].beadTypes,
          })
        "
      >
        <o-tooltip multiline position="bottom" size="small" :delay="300">
          <button
            type="button"
            name="parts_selected"
            :id="'beads_' + partsInfo[pid].beadId + 'i'"
            :value="partsInfo[pid].beadId"
            @click="
              (e) => {
                partsSelected = partsInfo[pid].beadId;
                e.preventDefault();
              }
            "
          >
            <IconBtoParts :parts-id="partsInfo[pid].beadId" />
          </button>
          <template v-slot:content>
            {{ partsInfo[pid].bead_name }}
            <p v-for="(item, k) in partsInfo[pid].prices" :key="k">
              {{ item[2] }}：<span>￥{{ item[4] }}</span>
              <PartsPriceStatus
                :discount-rate-id="item[5]"
                :qty-label="item[1]"
              />
            </p>
          </template>
        </o-tooltip>
      </li>
    </ul>
    <div id="link-parts-quality-list">
      天然石の品質一覧ページは<a
        href="https://tennnone.com/quality-list/"
        target="_blank"
        rel="noreferrer"
        >こちら
        <svg width="18" height="18" viewBox="0 0 24 24">
          <path
            d="M14,3V5H17.59L7.76,14.83L9.17,16.24L19,6.41V10H21V3M19,19H5V5H12V3H5C3.89,3 3,3.9 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V12H19V19Z"
          /></svg
      ></a>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import IconBtoParts from "@/components/BtoPanel/IconBtoParts.vue";
import PartsPriceStatus from "@/components/BtoPanel/PartsPriceStatus.vue";
import accessoryItemRestRepository from "@/mixins/BtoPanel/RepositoryAccessoryItemRest.js";

export default {
  name: "PartsPaletteList",

  mixins: [accessoryItemRestRepository],

  components: {
    IconBtoParts,
    PartsPriceStatus,
  },

  props: {
    partsInfo: {
      type: Object,
    },
    partsSortNum: {
      type: Object,
    },
    jewelleryItemId: {
      type: String,
    },
    jewelleryItemCode: {
      type: String,
    },
    designId: {
      type: Object,
    },
    coordinate: {
      type: Object,
    },
  },

  data() {
    return {};
  },

  computed: {
    /**
     * 選択中のパーツID
     * @type {Object}
     */
    partsSelected: {
      get() {
        return this.$store.state.current_parts_id;
      },
      set(value) {
        this.$store.commit("update_parts_id", value);
        this.$store.commit("update_id_holder_by_selected_parts", value);

        let hasSelected = Object.keys(this.$store.state.selected_parts_position)
          .length;

        if (hasSelected) {
          this.delayUpdateBtoResult();
        }
      },
    },

    /**
     * パーツオブジェクトを受け取って、使用可否の判定結果を返す
     * @return {Boolean} [description]
     */
    isEnabled() {
      return (parts) => {
        let ret = this.isInSelectedLabel(parts.labelCode);

        let types = this.selectedPartsTypes;

        if (ret && Object.keys(types).length) {
          let chk = false;
          for (let type_code in types) {
            chk =
              -1 == parts.beadTypes.search("bt_" + type_code) ? false : true;
            if (!chk) {
              break;
            }
          }
          ret = chk;
        }

        let size_key = "size_" + this.currentSizeId;
        if (this.coordinate[size_key].excludeds[parts.beadTypes.trim()]) {
          ret = false;
        }

        return ret;
      };
    },

    ...mapState({
      selectedPartsTypes: (state) => state.selected_parts_types,
      selectedPartsClass: (state) => state.selected_parts_class,
      selectedLabelCode: (state) => state.selectedLabelCode,
      currentSizeId: (state) => state.current_size_id,
    }),
  },

  methods: {
    /**
     * パーツオブジェクトを受け取って、選択中のラベルに属するかどうかを返す
     */
    isInSelectedLabel(labelCode) {
      let ret = false;
      if ("all" == this.selectedLabelCode) {
        ret = true;
    } else if (!labelCode ?? false) {
        ret = false;
      } else {
        ret =
          -1 == labelCode.search("l" + this.selectedLabelCode) ? false : true;
      }
      return ret;
    },

    ...mapActions(["update_bto_result"]),
  },
};
</script>

<style scoped lang="stylus">

#bto-parts-palette-list li
    background: none

@css {

	#bto-parts-palette-list {
    border-color: #efebe3;
    @apply border-solid border px-1 py-4 overflow-visible
  }
  #bto-parts-palette-list ul {
    grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr 1fr;
    @apply grid gap-2
  }
  #bto-parts-palette-list li {
    width: 28px;
    height: 28px;
    @apply p-0 justify-self-center transition-all duration-500
  }
  #bto-parts-palette-list button {
    @apply focus:outline-red
  }
  #link-parts-quality-list {
    @apply text-center mt-4
  }
  #link-parts-quality-list a {
    @apply underline
  }
  #link-parts-quality-list svg {
    @apply inline fill-current text-gray-400
  }

}
</style>
